import { InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import "./style.css";
import {
  setMultiFeature
} from "../../reducers/PredictionSlice"
import { toast } from "react-toastify";

const MAX_COLUMNS = 20;

const ExcelColumnSelector = ({
  setColumnValues,
  multiFeatures,
  excelData,
  setExcelData,
}) => {
  const dispatch = useDispatch();
  const [selectedColumn, setSelectedColumn] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState(""); // State for uploaded file name
  const handleFileUpload = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (multiFeatures) {
      dispatch(setMultiFeature())
    }
    setExcelData([]);
    setColumnValues([]);
    setSelectedColumn("");
    setUploadedFileName(file.name); // Set the uploaded file name
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryString = event.target.result;
      const workbook = XLSX.read(binaryString, { type: "binary" });
      const sheetName = workbook.SheetNames[0]; // Assuming the data is in the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false });
      const totalColumns = data[0]?.length ?? 0;
      const limitedData = totalColumns > MAX_COLUMNS
        ? data.map((row) => row.slice(0, MAX_COLUMNS))
        : data;
      if (totalColumns > MAX_COLUMNS) {
        toast.warning(`Excel file has ${totalColumns} columns. Only the first ${MAX_COLUMNS} will be used.`);
      }
      setExcelData(limitedData);
    };
    reader.readAsBinaryString(file);
  };

  const handleColumnSelect = (e) => {
    const selectedColumnIndex = excelData[0].indexOf(e.target.value);
    setSelectedColumn(e.target.value);
    const values = {};
    const dataArray = [];
    values[e.target.value] = excelData.slice(1).map((row) => row[selectedColumnIndex]);
    dataArray.push(values);
    setColumnValues(dataArray);
    console.log(`Values in selected column "${e.target.value}":`, values);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: ".xlsx, .xls",
    onDrop: handleFileUpload,
    multiple: false,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        style={{
          width: "60vw",
          border: "1px dashed black",
          padding: "7em",
          textAlign: "center",
        }}
      >
        <input {...getInputProps()} />
        <Typography fontSize={22}>
          {uploadedFileName ? `Uploaded File: ${uploadedFileName}` : "Drag and drop an Excel file here, or click to select one"}
        </Typography>
      </div>
      {!multiFeatures && excelData.length > 0 && (
        <div>
          <br />
          <InputLabel>Please select a column:</InputLabel>
          <Select
            size="small"
            fullWidth
            value={selectedColumn}
            onChange={handleColumnSelect}
          >
            {excelData[0].map((column, index) => (
              <MenuItem key={index} value={column}>
                {column}
              </MenuItem>
            ))}
          </Select>
        </div>
      )}
    </div>
  );
};

export default ExcelColumnSelector;
